module.exports = __webpack_public_path__ + "media/images/yellow_ball-7937de860fca70ab230d3052b92035d7.gif";